import React from "react";
import Template from "components/Template";
import PageTitle from "components/PageTitle";

const Lists = (): JSX.Element => {
  return (
    <Template>
      <PageTitle top={77} left={-177}>
        Listas
      </PageTitle>
    </Template>
  );
};

export default Lists;
